import { render } from "./VWarehouseNavigation.vue?vue&type=template&id=7dc55bbe"
import script from "./VWarehouseNavigation.vue?vue&type=script&lang=js"
export * from "./VWarehouseNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__